(function(angular){
	'use strict';

	angular
		.module('slideModule')
		.component('slide', {
			templateUrl: ['STATIC_BASE_PATH', function(STATIC_BASE_PATH) {
				return STATIC_BASE_PATH + '/static/html/ria/slide/slide.html';
			}],
			transclude: true,
			replace: true,
			bindings: {
				title: '@',
				subhead: '@',
				img: '@',
				cta: '@',
				slideNumber: '<',
				next: '=',
				back: '=',
				authenticated: '<'
			},
			controllerAs: 'slide'
		});
})(window.angular);